import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
type ImageViewProps = {
  src: string;
  fileName?: string;
};
const ImageView = t0 => {
  const $ = _c(12);
  const {
    src,
    fileName
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "viewers.preview"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("artifact", t1);
  const [loaded, setLoaded] = useState(false);
  const t2 = !loaded;
  let t3;
  if ($[1] !== fileName || $[2] !== t) {
    t3 = fileName ?? t(_temp);
    $[1] = fileName;
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setLoaded(true);
    t5 = () => setLoaded(true);
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== src || $[7] !== t3) {
    t6 = <img src={src} alt={t3} onLoad={t4} onError={t5} className="h-auto max-h-full max-w-full rounded-md border border-tertiary bg-primary shadow-sm" />;
    $[6] = src;
    $[7] = t3;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t2 || $[10] !== t6) {
    t7 = <div className="flex h-full w-full items-start justify-center overflow-auto" aria-busy={t2}>{t6}</div>;
    $[9] = t2;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
export default ImageView;
function _temp($) {
  return $.alt;
}